import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Store} from "@ngrx/store";
import {AuthenticationState} from "./authentication.reducers";


export interface InstagramLoginAccount {
  instagram_id: string;
  instagram_business_account_id: string;
  instagram_username: string;
  instagram_profile_picture_url: string;
}

export interface InstagramCallbackResult {
  accounts: InstagramLoginAccount[];
  redirectUrl: string | null;
}


@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  private apiUrl = environment.aws_resources.lambda_endpoint.api;

  constructor(
              private http: HttpClient,
              private _authenticationService: AuthenticationService,
              public store: Store<AuthenticationState>,
  ) {}



  loginFacebookToken(facebookToken: string) {
    let params = new HttpParams();
    params = params.append('code', facebookToken);
    return this.http.get(this.apiUrl + 'influencer-authentication/callback', { params }).pipe(
        map((credentials: any[]) => credentials.map(AuthenticationService.parseInstagramAccountsResponse))
    );
  }

  getCognitoCredentials(instagramAccount) {
    let params = new HttpParams();
    params = params.append('instagram_id', instagramAccount.instagram_id);
    params = params.append('instagram_business_account_id', instagramAccount.instagram_business_account_id);
    params = params.append('instagram_username', instagramAccount.instagram_username);
    params = params.append('instagram_profile_picture_url', instagramAccount.instagram_profile_picture_url);
    params = params.append('facebook_id', instagramAccount.facebook_id);

    return this.http.get(this.apiUrl + 'influencer-authentication/credentials', {observe: 'response', params});
  }

  loginInstagramCode(code: string, state?: string) {
    let params = new HttpParams();
    params = params.append('code', code);

    if (state) {
      params = params.append('state', state);
    }

    return this.http.get(this.apiUrl + 'influencer-authentication/instagram/callback', { params }).pipe(
        map((body: unknown) => AuthenticationService.parseInstagramCallbackBody(body))
    );
  }

  loginInstagramMetaError(error: string, state: string) {
    let params = new HttpParams();
    params = params.append('error', error);
    params = params.append('state', state);

    return this.http.get(this.apiUrl + 'influencer-authentication/instagram/callback', { params }).pipe(
        map((body: unknown) => AuthenticationService.parseInstagramCallbackBody(body))
    );
  }

  getInstagramCognitoCredentials(instagramId: string) {
    let params = new HttpParams();
    params = params.append('instagram_id', instagramId);
    return this.http.get(this.apiUrl + 'influencer-authentication/instagram/credentials', {
      observe: 'response',
      params,
    });
  }

  private static parseInstagramAccountsResponse(user) {
    return {
      instagram_id: user.instagram_id,
      instagram_business_account_id: user.instagram_business_account_id,
      instagram_username: user.instagram_username,
      instagram_profile_picture_url: user.instagram_profile_picture_url,
      facebook_id: user.facebook_id,
    };
  }

  private static parseInstagramLoginAccountsResponse(user): InstagramLoginAccount {
    return {
      instagram_id: user.instagram_id,
      instagram_business_account_id: user.instagram_business_account_id,
      instagram_username: user.instagram_username,
      instagram_profile_picture_url: user.instagram_profile_picture_url,
    };
  }

  /**
   * Generic Instagram callback returns an accounts array.
   * Opt-in callback returns { accounts, redirect_url } or { redirect_url } only.
   */
  private static parseInstagramCallbackBody(body: unknown): InstagramCallbackResult {
    if (Array.isArray(body)) {
      return {
        accounts: body.map(AuthenticationService.parseInstagramLoginAccountsResponse),
        redirectUrl: null,
      };
    }

    if (body && typeof body === 'object') {
      const payload = body as { accounts?: unknown[]; redirect_url?: string };
      const accounts = Array.isArray(payload.accounts)
          ? payload.accounts.map(AuthenticationService.parseInstagramLoginAccountsResponse)
          : [];
      const redirectUrl =
          typeof payload.redirect_url === 'string' && payload.redirect_url
              ? payload.redirect_url
              : null;

      return { accounts, redirectUrl };
    }

    return { accounts: [], redirectUrl: null };
  }

  // refreshSessionToken() {
  //   this.store.dispatch(actions.getCognitoCredentials({ instagramAccount: JSON.parse(localStorage.getItem('user')) }))
  // }

}
